/**
 * Phase 9 perf — idle-driven script injection.
 *
 * Wraps `requestIdleCallback` (rIC) with a `setTimeout` fallback for browsers
 * that still lack rIC (Safari < 17.2 as of 2026). Used by analytics, Calendly,
 * tracking and other non-critical third-party scripts to inject after the
 * browser is idle — so they never compete with critical rendering.
 *
 * Default timeout : 3000ms (browser will force-fire the callback even if the
 * main thread never becomes idle, e.g. on heavy ad pages).
 */
type IdleWin = Window & {
  requestIdleCallback?: (
    cb: () => void,
    opts?: { timeout: number }
  ) => number;
};

export function idleInject(cb: () => void, timeoutMs = 3000): void {
  if (typeof window === 'undefined') return;
  const idleWin = window as IdleWin;
  if (typeof idleWin.requestIdleCallback === 'function') {
    idleWin.requestIdleCallback(cb, { timeout: timeoutMs });
  } else {
    // Safari < 17.2 fallback : 1.5s assume page is settled.
    setTimeout(cb, 1500);
  }
}
